const ImageSize = {
  small: 40,
  medium: 350,
  large: 550,
};

// eslint-disable-next-line import/prefer-default-export
export { ImageSize };
